const LIST_ALL_CLIENTS = (state, payload) => {
  state.clients = payload;
}
const SET_TOTAL_CLIENTS = (state, payload) => {
  state.totalClients = payload;
}
const SET_PENDENCIES_CLIENTS = (state, payload) => {
  state.pendenciesClients = payload;
}
const SET_AVERAGE_PAYMENT_TIME = (state, payload) => {
  state.averagePaymentTime = payload;
}

export default {
  LIST_ALL_CLIENTS,
  SET_TOTAL_CLIENTS,
  SET_PENDENCIES_CLIENTS,
  SET_AVERAGE_PAYMENT_TIME
}
